import React from "react";

import Logout from "@assets/Icons/logout.svg";
import SidebarDrawerMenu from "@atoms/SidebarDrawerMenu";

import { MenuItem } from "@molecules/SidebarMenus";

import useTheme from "@styles/useTheme";

import useTranslation from "@languages/useTranslation";
import { GlobalMessages } from "@languages/interfaces/globalMessages";

const SidebarMenuItems: MenuItem[] = [
  {
    id: "6",
    title: GlobalMessages.logout,
    icon: Logout,
    link: "/"
  }
];

const SidebarDrawerSecondaryMenus: React.FC = () => {

  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <>
      {
        SidebarMenuItems.map(({ id, title, icon, link }) => (
          <SidebarDrawerMenu
            key={`${id}_${title}`}
            id={id}
            title={t(title)}
            icon={icon}
            link={link}
            secondaryColor={theme.colors.secondary}
            identifierColor={theme.colors.tertiary}
            type="secondary"
          />
        ))
      }
    </>
  );
};

export default React.memo(SidebarDrawerSecondaryMenus);
